import { GameDetailsOnBoardModeEnum } from 'config/constants'
import { Game } from 'config/types/game'
import { useIsomorphicEffect } from 'hooks/useIsomorphicEffect'
import useQueryParam from 'hooks/useQueryParam'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { useTokenSelected } from 'state/session/hooks'
import useValidateGame from './useValidateGame'

const useGameOnboardListener = (playGameFn: () => void, game: Game) => {
  const router = useRouter()
  const { removeParam } = useQueryParam()

  const playToken = useTokenSelected()

  const validateResult = useValidateGame(game)

  const isValid = useMemo(() => validateResult, [playToken, validateResult])

  useIsomorphicEffect(() => {
    if (!isValid) return

    const handle = async () => {
      const { onBoardType } = router.query
      switch (onBoardType) {
        case GameDetailsOnBoardModeEnum.PlayFreeSpin:
          playGameFn()
          break
        case GameDetailsOnBoardModeEnum.PlayFreeSpinWithSelectedCurrency:
          playGameFn()
          break

        default:
          break
      }

      await removeParam('onBoardType')
    }

    handle()
  }, [router.query.onBoardType, isValid])

  return null
}

export default useGameOnboardListener
